<template>
  <v-card
      class="mt-4"
      outlined
  >
    <v-card-title>
      {{ label }}
    </v-card-title>
    <v-divider/>
    <v-card-text>
      <v-row class="pa-4">
        <v-col cols="12">
          <v-autocomplete
              v-model="select"
              :loading="loading"
              :disabled="disabled"
              :items="items"
              :search-input.sync="search"
              item-text="value"
              return-object
              item-value="id"
              cache-items
              flat
              hide-no-data
              hide-details
              label="جستجو بین تگ ها"
              :append-icon="outer_icon"
              @click:append="add_tag(search)"
          ></v-autocomplete>
        </v-col>
        <v-col
            v-for="(selection, i) in selected_tags"
            :key="selection.id"
            class="shrink"
        >
          <v-chip
              :disabled="loading"
              close
              @click:close="selected_tags.splice(i, 1)"
          >
            {{ selection.value }}
          </v-chip>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "TagManager",
  mounted() {
    this.selected_tags = this.tags
  },
  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: [],
      selected_tags: [],
      addable: false
    }
  },
  props: {
    tags: Array,
    label: String,
    field_id: Number,
    disabled:{
      type: Boolean,
      default: false
    }
  },
  watch: {
    search(val) {
      this.search_query(val)
    },
    items() {
      this.addable = this.items.length === 0 && this.search !== null && !this.loading;
    },
    select() {
      if (!this.selected_tags.includes(this.select))
        this.selected_tags.push(this.select)
      this.search = ""
    },
    selected_tags(selected_tags_array){
      this.$emit('tag_change', {"selected_tags": selected_tags_array})
    }
  },
  methods: {
    search_query(value) {
      let context = this
      this.$store.dispatch('search_tag', {field_id: this.field_id, search_value: value}).then((response) => {
        context.items = response.results
      })
    },
    add_tag(value) {
      this.$store.dispatch('add_tag', {field_id: this.field_id, value: value}).then((response) => {
        if(!this.is_tag_exist(value)){
          console.log("im here")
          this.selected_tags.push(response)
        }
      })
    },
    is_tag_exist(tag_value){
      for(let i=0; i<this.selected_tags.length; i++){
        if(this.selected_tags[i].value === tag_value){
          return true;
        }
      }
      return false;
    }
  },
  computed: {
    outer_icon() {
      if (this.addable) {
        return "mdi-plus"
      } else
        return null
    }
  }
}
</script>

<style scoped>

</style>
